import ApiService from "../api";

export default class SapServiceRetornoEntrega extends ApiService {

    constructor() {
        super("/api/sap-retorno");
    }

    importar(data) {
        return this.post(`/upload`, data)
    }

    // Fluxo em 2 etapas, pra tela mostrar o andamento (removendo -> importando).
    prepararImportacao(data) {
        return this.post(`/importar/preparar`, data)
    }

    importarDados(processoId) {
        return this.post(`/importar/dados?processoId=${processoId}`)
    }

      listarRetornos(filtro) {
        return this.post("/listar", filtro);
    }

    editar(data) {
        return this.put("", data);
    }


    listar(values) {
        const params = new URLSearchParams();
        params.append('filialId', values.filialId);
        params.append('transporte', values.transporte);

        return this.get(`?${params.toString()}`)
    }

    listarOperacoesPorPeriodo(dataInicio, dataFim) {
        return this.get(`/dias-operacao/periodo?inicio=${dataInicio}&fim=${dataFim}`);
    }

    lista(values) {
        const params = new URLSearchParams();

        params.append('ano', values.ano);
        params.append('mes', values.mes);
        params.append('comissoes', values.comissoes);

        if (values.filialId) params.append('filialId', values.filialId);

        return this.get(`/lista?${params.toString()}`)
    }

}
